import React from 'react';
import { DeviceType } from '@landr/react-core';
import { useCreateContextHook } from 'contexts/useCreateContextHook';

export type ExecutionEnvironmentContextType = {
    isDAWPlugin: boolean;
    isBrowser: boolean;
    isDesktopApp: boolean;
    deviceType: DeviceType;
};
export interface ExecutionEnvironmentContextProviderProps {
    children: React.ReactNode;
    deviceType: DeviceType;
}

export const defaultExecutionEnvironmentContext: ExecutionEnvironmentContextType =
    {
        isDAWPlugin: false,
        isBrowser: true,
        isDesktopApp: false,
        deviceType: DeviceType.Browser,
    };

export const ExecutionEnvironmentContext =
    React.createContext<ExecutionEnvironmentContextType>(
        defaultExecutionEnvironmentContext,
    );

export const useExecutionEnvironmentContext = () => {
    const context = useCreateContextHook({
        context: ExecutionEnvironmentContext,
        errorMessage:
            'useExecutionEnvironmentContext must be used within a ExecutionEnvironmentProvider',
    });

    return context;
};

export const ExecutionEnvironmentProvider = ({
    children,
    deviceType,
}: ExecutionEnvironmentContextProviderProps): JSX.Element => {
    const isDAWPlugin = deviceType === DeviceType.SamplesPlugin;
    const isDesktopApp = deviceType === DeviceType.DesktopApp;
    const isBrowser = !isDAWPlugin && !isDesktopApp;

    return (
        <ExecutionEnvironmentContext.Provider
            value={{
                isDAWPlugin,
                isDesktopApp,
                isBrowser,
                deviceType,
            }}
        >
            {children}
        </ExecutionEnvironmentContext.Provider>
    );
};

export default ExecutionEnvironmentProvider;
